import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { Invoice } from "./invoice";

export interface ManualInvoice extends AttributesMixin<typeof ManualInvoice> { }
@define
export class ManualInvoice extends Model {
  static endpoint = restfulIO('api/v1/ingest/invoices');

  static attributes = {
    id: String,
    status: String,
    ...Invoice.attributes
  }

  public get hasProposedMonetization(): boolean {
    return true;
  }
}
